import { render, staticRenderFns } from "./MunicipioForm.vue?vue&type=template&id=6620d058"
import script from "./MunicipioForm.vue?vue&type=script&lang=js"
export * from "./MunicipioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports